import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { baseURL, moodleApiUrl, moodleToken } from "../auth/util/CustomConstants";
import axios from "axios";
import { loaderActions } from '../actions/loaderActions';

import Loader from "./Loader";
import fetchSearchItemsNextToken from "../../graphql/fetchSearchItemsNextToken";
import * as queries from "../../graphql/queries";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Header from "./Header";
import "./Assessment.css"
import { API, graphqlOperation } from "aws-amplify";
import {
    createAssessmentInstance,
    createAssessmentResponse,
    updateAssessmentResponse
} from "../../graphql/mutations";
import { Alert, Snackbar } from "@mui/material";


export default function Assessment() {

    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const params = new URLSearchParams();
    const [loading, setLoading] = useState(true);
    const [openToast, setOpenToast] = useState(false);
    const [toastMsg, setToastMsg] = useState("");
    const [severityClass, setSeverityClass] = useState("success");

    const [moodleUserID, setMoodleUserID] = useState(null)
    const [moodleRole, setMoodleRole] = useState(null)
    const [assessment, setAssessment] = useState(null)
    const userEmail = localStorage.getItem("email") || null
    const [cohorts, setCohorts] = useState([])

    // form variables only for teacher's view
    const [startTime, setStartTime] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [attemptLimit, setAttemptLimit] = useState(null)
    const [grade, setGrade] = useState(null)
    const [term, setTerm] = useState(0)

    const [gradeOptions, setGradeOptions] = useState([])
    const termOptions = [1, 2, 3, 4]
    const attemptLimitOptions = [1, 2, 3, 4]


    // student's variable
    const [started, setStarted] = useState(false)
    const [startAttempt, setStartAttempt] = useState(false)
    const [expireTime, setExpireTime] = useState(null)
    const [maxAttempt, setMaxAttempt] = useState(false)
    const [ended, setEnded] = useState(false)
    const [assessmentInstanceID, setAssessmentInstanceID] = useState(null)
    const [attempt, setAttempt] = useState(null)
    // const [assessmentInstance, setAssessmentInstance] = useState(null)
    const assessmentInstanceIDRef = useRef(assessmentInstanceID)
    const attemptRef = useRef(attempt)
    const iframeRef = useRef(null)
    const [warningMsg, setWarningMsg] = useState('');

    useEffect(() => {
        assessmentInstanceIDRef.current = assessmentInstanceID;
    }, [assessmentInstanceID]);

    useEffect(() => {
        attemptRef.current = attempt;
    }, [attempt])

    const handleCloseToast = () => {
        setOpenToast(false);
    }

    const customAPIRequest = async (fnName, data) => {
        try {
            let newURL = "";
            params.set("wstoken", moodleToken);
            params.set("wsfunction", fnName);
            params.set("moodlewsrestformat", "json");

            for (var key in data) {
                params.set(key, data[key]);
            }
            newURL = `${moodleApiUrl}?${params.toString()}`;

            let response = await axios.request(newURL);
            for (var key in data) {
                params.delete(key);
            }
            return response;
        } catch (error) {
            console.log("error ", error);
            setToastMsg("API request failed," + fnName);
            setSeverityClass("error");
            setOpenToast(true);
            return null;
        }
    }

    const isLoggedIn = () => {
        try {
            if (localStorage.getItem("userDetailsID") === "" || !localStorage.getItem("userDetailsID") || !localStorage.getItem("email")) {
                navigate(process.env.PUBLIC_URL + "/signin");
                return;
            }
        } catch (error) {
            console.log("error func(isLoggedIn) ", error);
            return;
        }
    }

    const isAssessmentAssigned = async () => {
        try {
            if (!userEmail) {
                throw new Error("User email is not provided");
            }

            // get moodle details of the user
            const moodleUserResponse = await customAPIRequest("core_user_get_users_by_field", { "field": "email", "values[0]": userEmail })

            if (!moodleUserResponse?.data?.length) {
                throw new Error("No Moodle user found: " + moodleUserResponse ? JSON.stringify(moodleUserResponse) : moodleUserResponse);
            }

            const moodleUser = moodleUserResponse.data[0];
            const moodleUserID = moodleUser?.id;

            //get assigned courses of the user
            const assignedCoursesResponse = await customAPIRequest("core_enrol_get_users_courses", { "userid": moodleUserID });

            if (!assignedCoursesResponse?.data?.length) {
                throw new Error("No assigned courses found: " + JSON.stringify(assignedCoursesResponse));
            }

            const assignedCourses = assignedCoursesResponse.data;

            // get all the assessment from the assigned courses
            const assignedCourseAssessmentsResponse = await Promise.all(
                assignedCourses.map(course =>
                    customAPIRequest(
                        "core_course_get_contents",
                        {
                            "courseid": course.id,
                            "options[0][name]": "modname",
                            "options[0][value]": "url"
                        }
                    ).then(response => ({ courseId: course.id, data: response }))
                )
            );

            // check if the assessment id is there in assignedCoursesAssessmentsResponse array
            const isAssignedAssessment = assignedCourseAssessmentsResponse.find(courseResponse =>
                courseResponse?.data?.data
                    .flatMap(section => section?.modules || [])
                    .flatMap(module => module?.contents || [])
                    .some(content => content?.fileurl && content.fileurl.includes(id))
            );

            if (isAssignedAssessment?.courseId) {
                return { courseId: isAssignedAssessment.courseId, moodleUserId: moodleUserID };
            }

            return null;

        } catch (error) {
            console.log("Error in isAssessmentAssigned function :\n", error);
            return null
        }
    }

    const getMoodleRole = async (courseid, moodleUserId) => {
        try {

            // get enrolled user using course id
            const enrolledUsersResponse = await customAPIRequest("core_enrol_get_enrolled_users", { courseid });

            if (!enrolledUsersResponse?.data?.length) {
                throw new Error("No users enrolled in the course");
            }

            const user = enrolledUsersResponse.data.find(user => user?.id === moodleUserId);

            if (!user) {
                throw new Error("User not found in the enrolled users");
            }

            let hasTeacherRole = false;
            let hasStudentRole = false;

            // check roles assigned to the user
            user.roles.forEach(role => {
                if (role.roleid === 11) {
                    hasTeacherRole = true;
                } else if (role.roleid === 14) {
                    hasStudentRole = true;
                }
            });

            // if the user have both teacher & student roles. then assign teacher role
            if (hasTeacherRole) return "teacher"
            if (hasStudentRole) return "student"
            return null;  
        } catch (error) {
            console.log("Error in getMoodleRole function: ", error)
            return null
        }
    }

    // this reset is only for teacher role
    const reset = () => {
        setStartTime(null)
        setEndTime(null)
        setAttemptLimit(null)
        setGrade(null)
        setTerm(null)
    }

    const formatDate = (date) => {
        // Extract the components of the date
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // The hour '0' should be '12'
        const strMinutes = minutes < 10 ? '0' + minutes : minutes;

        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are zero-based
        const year = date.getFullYear();

        // Format the date components
        const strHours = hours < 10 ? '0' + hours : hours;
        const strDay = day < 10 ? '0' + day : day;
        const strMonth = month < 10 ? '0' + month : month;

        // Combine them into the desired format
        return `${strDay}/${strMonth}/${year} - ${strHours}:${strMinutes} ${ampm}`;
    }

    const getAssessmentDetails = async (uid) => {
        try {
            const assessmentDetailsResponse = await fetchSearchItemsNextToken({
                query: queries.searchAssessments,
                variables: { filter: { url: { eq: uid } } }
            })
            if (assessmentDetailsResponse?.length > 0) {
                return assessmentDetailsResponse[0]
            } else {
                throw new Error("Assessment details not found" + assessmentDetailsResponse)
            }
        } catch (error) {
            console.log("Error in getAssessmentDetails function", error)
            return null
        }
    }

    const getCohort = async (email, courseID) => {
        try {
            if (!courseID || !email || email.trim() === "") {
                throw new Error("Invalid input: courseID and email must be provided")
            }

            const response = await fetchSearchItemsNextToken({
                query: queries.searchCohorts, variables: {
                    filter: { teacher_email: { eq: email }, moodle_course_id: { eq: courseID } }
                }
            })

            if (!response?.length) {
                throw new Error("No cohorts found")
            }

            setGradeOptions(response.map(cohort => ({ "grade": cohort.grade, "div": cohort.class })))
            setCohorts(response)
            return true

        } catch (error) {
            console.log("Error in getCohort function : ", error)
            return null
        }
    }

    const getAssessmentInstance = async (id, email) => {
        try {
            if (!id || id === "" || !email || email === "") {
                throw new Error("Assessment ID is not valid : ", id)
            }
            const now = new Date().getTime()

            // fetch assessmentInstance using time 
            const response = await fetchSearchItemsNextToken({
                query: queries.searchAssessmentInstances, variables: {
                    filter: { assessmentInstancesId: { eq: id }, start_time: { lte: now }, end_time: { gt: now } }
                }
            })

            if (!response?.length) {
                throw new Error("No Active Assessment found")
            }

            // check if user exists in the students array
            let activeAssessmentInstance = response.find(assessment => {
                if (assessment?.students && assessment.students !== "") {
                    let arrOfStudents = JSON.parse(assessment.students.replace(/'/g, '"'))
                    if (arrOfStudents?.length > 0) {
                        if (arrOfStudents.some(student => student === email)) {
                            return true
                        }
                    }
                }
            })

            return activeAssessmentInstance || null

        } catch (error) {
            console.log("Error in getAssessmentInstance function", error)
            return null
        }
    }

    const getAttemptOfStudent = async (assessmentInstanceID, email) => {
        try {
            const response = await fetchSearchItemsNextToken({
                query: queries.searchAssessmentResponses, variables: {
                    filter: { assessment_instance_id: { eq: assessmentInstanceID }, student_email: { eq: email } },
                }
            })

            if (response.length > 0) {
                return response[0]
            } else {
                return null
            }
        } catch (error) {
            console.log("Error in getAttemptOfStudent function", error)
            return null
        }
    }

    const registerAttempt = async (e) => {
        dispatch(loaderActions.start())
        setLoading(true)
        let response;
        try {
            if (attempt) {
                const assessmentResponseObj = {
                    id: attempt.id,
                    attempt_count: attempt.attempt_count + 1
                }
                response = await API.graphql(graphqlOperation(updateAssessmentResponse, { input: assessmentResponseObj }))
            } else {
                const email = localStorage.getItem("email") || null
                const profileID = localStorage.getItem("userDetailsID") || null

                const studentDetailsResponse = await fetchSearchItemsNextToken({ query: queries.searchUserProfileDetails, variables: { filter: { id: { eq: profileID } } } })
                
                if (studentDetailsResponse && studentDetailsResponse.length > 0) {
                    const assessmentResponseObj = {
                        assessment_instance_id: assessmentInstanceIDRef.current,
                        total_score: "",
                        result: "",
                        score: "",
                        student_id: profileID,
                        student_email: email,
                        student_name: `${studentDetailsResponse[0]?.first_name} ${studentDetailsResponse[0]?.last_name}`,
                        attempt_count: 1,
                        duration: "",
                    }

                    response = await API.graphql(graphqlOperation(createAssessmentResponse, { input: assessmentResponseObj }))
                } else {
                    throw new Error("Can't find student detail")
                }


            }
            if (response) {
                setStartAttempt(true)
                setAttempt(response?.data?.createAssessmentResponse || response?.data?.updateAssessmentResponse || null)
            } else {
                throw new Error("response of create/update assessmentResponse is null")
            }
        } catch (error) {
            setToastMsg("Something went wrong, while registering attempt");
            setSeverityClass("error");
            setOpenToast(true);

            console.log("Error in registerAttempt function: ", error)
            return null
        } finally {
            dispatch(loaderActions.stop())
            setLoading(false)
        }
    }

    const submitHandler = async () => {
        dispatch(loaderActions.start())
        setLoading(true)
        try {

            let now = new Date().getTime()
            if (term) {
                if (grade && grade !== "") {
                    if (attemptLimit && attemptLimit !== "") {
                        if (startTime) {
                            let start = new Date(startTime).getTime().toString()
                            let students = ""
                            let cohortID = ""
                            if (start > now) {
                                if (endTime) {
                                    let end = new Date(endTime).getTime().toString()
                                    if (end > start) {
                                        const standard = grade.split("_")[0]
                                        const div = grade.split("_")[1]
                                        const email = localStorage.getItem("email")

                                        cohorts.map(cohort => {
                                            if (cohort.class === div && cohort.grade === standard) {
                                                students = cohort.students.replace(/"/g, "'")
                                                cohortID = cohort.moodle_cohort_id.toString()
                                            }
                                        })
                                        if (students && students !== "") {
                                            let selectedTerm = parseInt(term)
                                            let selectedAttemptLimit = parseInt(attemptLimit)
                                            const assessmentInstance = {
                                                start_time: start,
                                                end_time: end,
                                                cohort_id: cohortID,
                                                students: students,
                                                teacher_email: email,
                                                status: 0,
                                                term: selectedTerm,
                                                attempt_limit: selectedAttemptLimit,
                                                assessmentInstancesId: assessment.id,
                                                is_report_sent: 0
                                            }

                                            const response = await fetchSearchItemsNextToken({
                                                query: queries.searchAssessmentInstances, variables: {
                                                    filter: {
                                                        assessmentInstancesId: { eq: assessment.id },
                                                        cohort_id: { eq: cohortID },
                                                        or: { end_time: { gte: start }, start_time: { lte: end } }
                                                    }
                                                }
                                            })

                                            if (response?.length > 0) {
                                                setToastMsg("There is already an active assessment.");
                                                setSeverityClass("error");
                                                setOpenToast(true);
                                            } else {
                                                const createInstance = await API.graphql(graphqlOperation(createAssessmentInstance, { input: assessmentInstance }))
                                                if (createInstance?.data?.createAssessmentInstance) {
                                                    setToastMsg("Assessment created successfully and it will start on " + new Date(parseInt(start)).toLocaleString('en-GB', { hour12: true, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }));
                                                    setSeverityClass("success");
                                                    setOpenToast(true);
                                                    reset()
                                                } else {
                                                    throw new Error(createInstance.toString())
                                                }
                                            }


                                        } else {
                                            throw new Error("List of students not found")
                                        }
                                    } else {
                                        setToastMsg("Please select an appropriate end time");
                                        setSeverityClass("error");
                                        setOpenToast(true);
                                    }
                                } else {
                                    setToastMsg("Please select end time");
                                    setSeverityClass("error");
                                    setOpenToast(true);
                                }
                            } else {
                                setToastMsg("Please select an appropriate start time");
                                setSeverityClass("error");
                                setOpenToast(true);
                            }
                        } else {
                            setToastMsg("Please select start time");
                            setSeverityClass("error");
                            setOpenToast(true);
                        }
                    } else {
                        setToastMsg("Please select the attempt limit");
                        setSeverityClass("error");
                        setOpenToast(true);
                    }
                } else {
                    setToastMsg("Please select grade");
                    setSeverityClass("error");
                    setOpenToast(true);
                }
            } else {
                setToastMsg("Please select term");
                setSeverityClass("error");
                setOpenToast(true);
            }

        } catch (error) {
            setToastMsg("Something went wrong");
            setSeverityClass("error");
            setOpenToast(true);

            console.log("Error func(submitHandler): ", error)
        } finally {
            dispatch(loaderActions.stop())
            setLoading(false)
        }
    }

    const submitResponse = async (event) => {
        if (event.origin === 'https://d3miq8k3kfqo5s.cloudfront.net' || event.origin === 'https://d3awjl27jexv21.cloudfront.net') {
            if (attemptRef?.current && attemptRef.current.attempt_count === 1) {
                const data = JSON.parse(event.data)
                if (data && data.passing_score) {
                    const totalScore = ((parseInt(data.passing_score) / parseInt(data.passing_per)) * 100).toString()
                    const result = parseInt(data.awarded_score) >= parseInt(data.passing_score) ? "pass" : "fail"
                    const duration = (parseInt(data.duration) / 60).toString()

                    const assessmentResponseObj = {
                        id: attemptRef.current.id,
                        total_score: totalScore,
                        result: result,
                        score: data.awarded_score,
                        duration: duration,
                    }

                    const submitResponse = await API.graphql(graphqlOperation(updateAssessmentResponse, { input: assessmentResponseObj }))
                } else {
                    console.log("Something wrong with response data or assessmentInstanceID :\n", data, "\n", assessmentInstanceIDRef)
                }
            }
            const navigateToMyFeedsPage = () =>{
                navigate("/my-feed")
            }
            setTimeout(navigateToMyFeedsPage, 10000)
            setSeverityClass("success")
            setToastMsg("Response submitted Successfully, You'll be redirected in 10 seconds")
            setOpenToast(true)
        }
    };

    useEffect(() => {
        dispatch(loaderActions.start())
        setLoading(true)
        isLoggedIn()
        const init = async () => {
            window.addEventListener('message', submitResponse);
            try {
                dispatch(loaderActions.start())
                setLoading(true)
                const isAssigned = await isAssessmentAssigned()
                if (isAssigned?.courseId) {
                    const moodleUserRole = await getMoodleRole(isAssigned.courseId, isAssigned.moodleUserId)
                    setMoodleUserID(isAssigned.moodleUserId)

                    if (moodleUserRole) {
                        setMoodleRole(moodleUserRole)
                        const assessmentDetails = await getAssessmentDetails(id)
                        if (assessmentDetails) {
                            setAssessment(assessmentDetails)
                            if (moodleUserRole === "teacher") {
                                const userCohortsResponse = await getCohort(localStorage.getItem("email") || null, isAssigned.courseId)
                                if (!userCohortsResponse) {
                                    setToastMsg("You don't have access to this assessment (not enrolled in cohort)");
                                    setSeverityClass("error");
                                    setOpenToast(true);
                                }
                            } else if (moodleUserRole === "student") {
                                const assessmentInstanceResponse = await getAssessmentInstance(assessmentDetails.id, localStorage.getItem("email") || null)
                               
                                if (assessmentInstanceResponse) {
                                    const attemptResponse = await getAttemptOfStudent(assessmentInstanceResponse.id, localStorage.getItem("email") || null)
                                    
                                    if (attemptResponse) {
                                        setAttempt(attemptResponse)
                                        if (attemptResponse && attemptResponse?.attempt_count && assessmentInstanceResponse) {
                                            if ((attemptResponse.attempt_count >= assessmentInstanceResponse.attempt_limit) && assessmentInstanceResponse.attempt_limit !== 0) {
                                                setMaxAttempt(true)
                                            }
                                        }
                                    }

                                    setExpireTime(parseInt(assessmentInstanceResponse.end_time))
                                    setAssessmentInstanceID(assessmentInstanceResponse.id)
                                    setStarted(true)
                                } else {
                                    setToastMsg("There are no active assessment");
                                    setSeverityClass("error");
                                    setOpenToast(true);
                                }
                            }
                        } else {
                            setToastMsg("Something went wrong, can't load assessment");
                            setSeverityClass("error");
                            setOpenToast(true);
                        }
                    } else {
                        setToastMsg("You don't have access to this assessment (invalid role)");
                        setSeverityClass("error");
                        setOpenToast(true);
                    }
                } else {
                    setToastMsg("You don't have access to this assessment (not assigned)");
                    setSeverityClass("error");
                    setOpenToast(true);
                }
            } catch (error) {
                setToastMsg("Something went wrong");
                setSeverityClass("error");
                setOpenToast(true);

                console.log("Error ", error)
            } finally {
                dispatch(loaderActions.stop())
                setLoading(false)
            }
        }
        init()
    }, [])

    useEffect(() => {
        if (moodleRole === "student") {
            if (assessment && maxAttempt) {
                setWarningMsg("You've reached the maximum number of attempts.");
            } else if (!assessment && !started) {
                setWarningMsg("Access denied. You do not have permission to take this assessment.");
            } else if (assessment && !started) {
                setWarningMsg("The assessment is currently inactive. Please wait for it to be activated.");
            } else if (assessment && started && ended) {
                setWarningMsg("Time's up! The assessment is now closed.");
            } else {
                setWarningMsg('');
            }
        }

    }, [moodleRole, assessment, maxAttempt, started, ended]);

    useEffect(() => {
        let timer;
        if (expireTime) {
            const checkTime = () => {
                const now = new Date().getTime()
                if (now > expireTime) {
                    setEnded(true)
                    clearTimeout(timer)
                } else {
                    timer = setTimeout(checkTime, 1000)
                }
            }
            checkTime()
        }
        return () => clearTimeout(timer)
    }, [expireTime])

    return loading ? (
        <Loader />
    ) : (
        <div>
            <Header />
            <Snackbar
                open={openToast}
                autoHideDuration={5000}
                onClose={handleCloseToast}
            >
                <Alert
                    variant="filled"
                    onClose={handleCloseToast}
                    severity={severityClass}
                    sx={{ width: "100%" }}
                >
                    {toastMsg}
                </Alert>
            </Snackbar>
            {(moodleRole === null || moodleRole === undefined) && (
                <>
                    <div className="view_assessment student">
                        <div className="warning_msg">No Access
                        </div>
                    </div>
                </>
            )}
            {moodleRole && moodleRole === "teacher" && (
                <>
                    <div className="view_assessment">
                        {assessment && (
                            <>
                                <iframe className="assessment" src={assessment.file_url} title="assessment"></iframe>
                            </>
                        )}
                    </div>
                    <div className="form_wrapper">
                        <div className="form_title">Start Assessment</div>
                        <div className="form_box">
                            <div className="section">
                                <div className="input_wrapper">
                                    <label>Term</label>
                                    <select
                                        onChange={e => setTerm(e.target.value)}
                                    >
                                        <option key="null" value={""}>Select Term</option>
                                        {termOptions && termOptions?.length > 0 && termOptions.map(elem =>
                                            <option key={elem} value={elem}>{elem}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="input_wrapper">
                                    <label>Grade</label>
                                    <select
                                        onChange={e => setGrade(e.target.value)}
                                    >
                                        <option key="null" value={""}>Select Grade - Division</option>
                                        {gradeOptions && gradeOptions?.length > 0 && gradeOptions.map(elem =>
                                            <option key={elem.grade + "_" + elem.div} value={elem.grade + "_" + elem.div}>{elem.grade + " - " + elem.div}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="input_wrapper">
                                    <label>Attempt Limit</label>
                                    <select
                                        onChange={e => setAttemptLimit(e.target.value)}
                                    >
                                        <option key="null" value={""}>Select attempt limit</option>
                                        {attemptLimitOptions && attemptLimitOptions?.length > 0 && attemptLimitOptions.map(elem =>
                                            <option key={elem} value={elem}>{elem}</option>
                                        )}
                                        <option key="0" value={0}>No Limit</option>
                                    </select>
                                </div>
                            </div>
                            <div className="section">
                                <div className="input_wrapper">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker value={startTime} onChange={newValue => setStartTime(newValue)} label="Start Time" />
                                    </LocalizationProvider>
                                </div>
                                <div className="input_wrapper">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker value={endTime} onChange={newValue => setEndTime(newValue)} label="End Time" />
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <div className="section">
                                <button className="btn"
                                    onClick={submitHandler}
                                >Start Assessment</button>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {moodleRole && moodleRole === "student" && (
                <>
                    <div className="view_assessment student">
                        {assessment && !maxAttempt && started && !ended && (
                            <>
                                {startAttempt ?
                                    <>
                                        <span className="info">{attempt && attempt.attempt_count > 1 && 'You have already attempted this assessment. Your initial response will be considered.'}<br />Ensure you submit your response before the deadline; otherwise, you will not receive any points/score.</span>
                                        <iframe ref={iframeRef} className="assessment" src={assessment.file_url} title="assessment"></iframe>
                                        <span className="info">This assessment will expire on {expireTime && formatDate(new Date(expireTime))}</span>
                                    </>
                                    :
                                    <>
                                        <span className="before info">Once you click the button below, make sure to submit your response before the deadline; otherwise, you will not receive any points/score.<br /> Do not refresh the page or go back after starting the attempt.<br />Only your initial response will be considered.</span>
                                        <button className="btn" onClick={registerAttempt} >START ATTEMPT</button>
                                    </>
                                }
                            </>
                        )}
                        {warningMsg && (
                            <div className="warning_msg">{warningMsg}</div>
                        )}
                        {/* {assessment && maxAttempt && (
                            <>
                                <div className="warning_msg">You've reached maximum number of attempts.</div>
                            </>
                        )}
                        {!assessment && !started && (
                            <>
                                <div className="warning_msg">Access denied. You do not have permission to take this assessment.</div>
                            </>
                        )}
                        {assessment && !started && (
                            <>
                                <div className="warning_msg">The assessment is currently inactive. Please wait for it to be activated.</div>
                            </>
                        )}
                        {assessment && started && ended && (
                            <>
                                <div className="warning_msg">Time's up! The assessment is now closed.</div>
                            </>
                        )} */}
                    </div>
                </>
            )}
        </div>
    )
}